import { Injectable } from '@angular/core';
import { CarrierNotes } from 'cargo-chief-commons';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class NotesService {
	private notesAddedSubject = new BehaviorSubject<CarrierNotes>(null);
	private visibleCarriersUpdatedSubject = new BehaviorSubject<string[]>(null);

	constructor() {}

	sendNotesAddedEvent(data: CarrierNotes) {
		this.notesAddedSubject.next(data);
	}

	getNotesAddedEvent(): Observable<CarrierNotes> {
		return this.notesAddedSubject.asObservable();
	}

	sendVisibleCarriersUpdatedEvent(data: string[]) {
		this.visibleCarriersUpdatedSubject.next(data);
	}

	getVisibleCarriersUpdatedEvent(): Observable<string[]> {
		return this.visibleCarriersUpdatedSubject.asObservable();
	}
}
